import React, { useState } from 'react';
import './LoadFieldOpDetail.scss';
import { Row, Col } from 'react-bootstrap';
import TextContent from '../../_common/TextContent/TextContent';
import { CustomButton, Loading, Textfield } from '../../_common';
import SearchableDropdown from '../../_common/SearchableDropdown/SearchableDropdown';
import SignaturePadComponent, { SignaturePadRef } from '../../_common/SignaturePad/SignaturePad';
import { useQuery } from '@apollo/client/react';
import {
    GET_FIELD_OP_BOXES,
    GET_EMPTY_BOXES,
    GET_STAGES_BY_JOB_ID,
    GET_CHASIS_DATA,
} from '../../../graphql/client/queries';
import {
    GetEmptyBoxes,
    GetEmptyBoxes_getEmptyBoxes_emptyBoxDetails as EmptyBoxes,
    GetBoxes_getBoxes_boxDetails as BoxDetails,
    GetFieldOpBoxes,
    GetWellheadsByStageGroupId_getWellheadsByStageGroupId as StageDetails,
    GetStagesByJobId,
    GetAllChasisData,
    GetAllChasisData_getAllChasisData as ChasisDetails,
} from '../../../types/schemaTypes';
import useEditLoadFieldOpForm from './useEditLoadFieldOpForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import useEditLoadFieldOpForm from './useEditLoadFieldOpForm';

interface LoadDetailProps {
    loadId: number | 0;
}
interface Option {
    id: number | string;
    name: string | number;
}

interface DbIds {
    boxId: number;
    chassisId: number;
}

const LoadFieldOpDetail = ({
    loadDetailData,
    loadProgressData1,
    sandTicketComponent,
    jobId,
    proppantId,
}: any): React.ReactElement => {
    const stages: Option[] = [];
    const boxes: Option[] = [];
    const emptyBoxes: Option[] = [];
    const chasis: Option[] = [];

    const checkForChassisNumber = (): string => {
        if (!loadDetailData.isSplit) {
            if (loadDetailData.chassisId != 0) {
                return loadDetailData.chassisNumber;
            } else return '';
        } else {
            if (loadDetailData.secondaryChassisId != 0) {
                return loadDetailData.secondaryChassisNumber;
            } else return '';
        }
    };

    const checkForBoxNumber = (): string => {
        if (loadDetailData.boxId != 0) {
            return loadDetailData.boxNumber;
        } else return '';
    };

    const checkForTruckNumber = (): string => {
        if (!loadDetailData.isSplit) {
            if (loadDetailData.truckNumber != null && loadDetailData.truckNumber != '') {
                return loadDetailData.truckNumber;
            } else return '';
        } else {
            if (loadDetailData.secondaryTruckNumber != null && loadDetailData.secondaryTruckNumber != '') {
                return loadDetailData.secondaryTruckNumber;
            } else return '';
        }
    };

    const [emptyBoxesCount, setEmptyBoxesCount] = useState(0);
    const { loading: stagesDataLoading, error, data: stagesData } = useQuery<GetStagesByJobId>(GET_STAGES_BY_JOB_ID, {
        variables: { jobId, proppantId },
        fetchPolicy: 'network-only',
    });

    const { data: boxesData } = useQuery<GetFieldOpBoxes>(GET_FIELD_OP_BOXES, {
        variables: { jobId },
        fetchPolicy: 'network-only',
    });

    const { data: emptyBoxesData } = useQuery<GetEmptyBoxes>(GET_EMPTY_BOXES, {
        variables: { jobId },
        fetchPolicy: 'network-only',
    });

    const { data: chasisData } = useQuery<GetAllChasisData>(GET_CHASIS_DATA, {
        variables: { jobId },
        fetchPolicy: 'network-only',
    });

    if (boxesData?.getFieldOpBoxes?.boxDetails) {
        boxesData.getFieldOpBoxes.boxDetails.forEach((element) => {
            if (element) {
                boxes.push({
                    id: element.boxId ?? 0,
                    name: element.boxDesc ?? '',
                });
            }
        });
    }

    if (emptyBoxesData?.getEmptyBoxes?.emptyBoxDetails) {
        emptyBoxesData.getEmptyBoxes.emptyBoxDetails.forEach((element) => {
            if (element) {
                emptyBoxes.push({
                    id: element.boxId ?? 0,
                    name: element.boxDesc ?? '',
                });
            }
        });
    }

    if (stagesData?.getStagesByJobId) {
        stagesData.getStagesByJobId.forEach((element) => {
            if (element) {
                stages.push({
                    id: element.jobStageId,
                    name: (element.wellhead ?? '') + ' - Stage ' + (element.stage ?? ''),
                });
            }
        });
    }
    if (chasisData?.getAllChasisData) {
        chasisData.getAllChasisData.forEach((element) => {
            if (element) {
                chasis.push({
                    id: element.id ?? 0,
                    name: element.sbsId ?? '',
                });
            }
        });
    }

    const {
        handleSignature,
        handleSubmit,
        handleAutoCompleteChange,
        inputs,
        fieldErrors,
        disable,
        handleInputChangeForRequiredFields,
        handleEmptyBoxes,
        mutationFieldLoading,
    } = useEditLoadFieldOpForm(loadDetailData, loadProgressData1);

    const changeStatus = (event: any): void => {
        setEmptyBoxesCount(event.target.value);
        handleEmptyBoxes(event.target.value);
        if (event.target.value === 1 || event.target.value === 2) {
        }
    };

    const signatureCanvasRef = React.createRef<SignaturePadRef>();
    const handleSignatureEnd = () => {
        const canvas = signatureCanvasRef.current;
        if (!canvas) return;
        const isEmpty = canvas.isEmpty();
        let signatureBase64 = canvas.toDataURL();
        signatureBase64 = signatureBase64.split(',')[1];
        handleSignature(isEmpty, signatureBase64);
    };

    const signatureCanvasRefTab = React.createRef<SignaturePadRef>();
    const handleSignatureEndTab = () => {
        const canvasTab = signatureCanvasRefTab.current;
        if (!canvasTab) return;
        const isEmptyTab = canvasTab.isEmpty();
        let signatureBase64Tab = canvasTab.toDataURL();
        signatureBase64Tab = signatureBase64Tab.split(',')[1];
        handleSignature(isEmptyTab, signatureBase64Tab);
    };
    const clearSignatureTab = () => {
        signatureCanvasRefTab.current?.clear();
        handleSignature(true, '');
    };

    const clearSignature = () => {
        signatureCanvasRef.current?.clear();
        handleSignature(true, '');
    };

    if (mutationFieldLoading) {
        return <Loading />;
    }
    const searchIcon = <FontAwesomeIcon icon={{ prefix: 'fas', iconName: 'search' }} />;

    return (
        <React.Fragment>
            <div className="LoadFieldOpDetails">
                <div className="LoadFieldOp-LoadDetails">
                    <div className="LoadFieldOp-LoadDetailsContainer">
                        <Row>
                            <Col md={6}>
                                <Textfield
                                    label="Load Id"
                                    name="loadId"
                                    value={loadDetailData.loadId.toString() || ''}
                                    maxLength={40}
                                    disabled={true}
                                    required
                                />
                            </Col>
                            <Col md={6}>
                                <Textfield
                                    label="Customer Name"
                                    name="customerName"
                                    value={loadDetailData.customerName || ''}
                                    disabled={true}
                                    required
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Textfield
                                    label="Well Name"
                                    name="wellName"
                                    value={loadDetailData.jobName || ''}
                                    maxLength={40}
                                    disabled={true}
                                    required
                                />
                            </Col>
                            <Col md={6}>
                                <Textfield
                                    label="Lofa Name"
                                    name="loadingFacility"
                                    value={loadDetailData.loadingFacility || ''}
                                    maxLength={40}
                                    disabled={true}
                                    required
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Textfield
                                    label="Carrier Name"
                                    name="carrierName"
                                    value={loadDetailData.carrierName || ''}
                                    maxLength={40}
                                    disabled={true}
                                    required
                                />
                            </Col>
                            <Col md={6}>
                                <Textfield
                                    label="Truck Number"
                                    name="truckNumber"
                                    onChange={event => {
                                        handleInputChangeForRequiredFields(event);
                                    }}
                                    value={checkForTruckNumber()}
                                    error={fieldErrors.truckNumberError !== ''}
                                    helperText={fieldErrors.truckNumberError}
                                    maxLength={40}
                                    disabled={false}
                                    required
                                />
                            </Col>
                        </Row>
                        {!loadDetailData.isBellyDump && <Row>
                            <Col md={6}>
                                <SearchableDropdown
                                    autoCompleteEnabled={true}
                                    dropdownOptions={chasis}
                                    errorMessage={fieldErrors.chassisNumberError}
                                    hasError={fieldErrors.chassisNumberError !== ''}
                                    id="chassisNumber"
                                    label="Chassis"
                                    onSelect={(eventKey: string | null) => {
                                        handleAutoCompleteChange('chassisNumber', {
                                            id: eventKey,
                                            name: 'chassisNumber',
                                        });
                                    }}
                                    required
                                    value={checkForChassisNumber()}
                                    endIcon={searchIcon}
                                />
                            </Col>
                            <Col md={6}>
                                <SearchableDropdown
                                    autoCompleteEnabled={true}
                                    dropdownOptions={boxes}
                                    errorMessage={fieldErrors.boxNumberError}
                                    hasError={fieldErrors.boxNumberError !== ''}
                                    id="boxNumber"
                                    label="Box Number"
                                    onSelect={(eventKey: string | null) => {
                                        handleAutoCompleteChange('boxNumber', {
                                            id: eventKey,
                                            name: 'boxNumber',
                                        });
                                    }}
                                    required
                                    value={checkForBoxNumber()}
                                    endIcon={searchIcon}
                                />
                            </Col>
                        </Row>}
                        <Row>
                            <Col md={6}>
                                <Textfield
                                    label="Proppant"
                                    name="proppant"
                                    value={loadDetailData.proppantName || ''}
                                    maxLength={40}
                                    disabled={true}
                                    required
                                />
                            </Col>
                            <Col md={6}>
                                <Textfield
                                    label="Miles"
                                    name="milesToWell"
                                    value={loadProgressData1?.milesToWell || ''}
                                    maxLength={40}
                                    disabled={true}
                                    required
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Textfield
                                    label="Sand PO"
                                    name="sandpo"
                                    value={loadDetailData.sandPO || ''}
                                    maxLength={40}
                                    disabled={true}
                                    required
                                />
                            </Col>
                            <Col md={6}>
                                <Textfield
                                    label="Sand Ticket Number"
                                    name="sandTicketNumber"
                                    onChange={event => {
                                        handleInputChangeForRequiredFields(event);
                                    }}
                                    value={loadProgressData1?.sandTicketNumber || ''}
                                    error={fieldErrors.sandTicketNumberError !== ''}
                                    helperText={fieldErrors.sandTicketNumberError}
                                    maxLength={40}
                                    disabled={false}
                                    required
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Textfield
                                    label="Gross Weight"
                                    name="grossWeight"
                                    onChange={event => {
                                        handleInputChangeForRequiredFields(event);
                                    }}
                                    value={loadProgressData1?.grossWeight || ''}
                                    error={fieldErrors.grossWeightError !== ''}
                                    helperText={fieldErrors.grossWeightError}
                                    maxLength={40}
                                    disabled={false}
                                    required
                                />
                            </Col>
                            <Col md={6}>
                                <Textfield
                                    label="Tare Weight"
                                    name="tareWeight"
                                    onChange={event => {
                                        handleInputChangeForRequiredFields(event);
                                    }}
                                    value={loadProgressData1?.tareWeight || ''}
                                    error={fieldErrors.tareWeightError !== ''}
                                    helperText={fieldErrors.tareWeightError}
                                    maxLength={40}
                                    disabled={false}
                                    required
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Textfield
                                    label="Net Weight"
                                    name="netWeight"
                                    onChange={event => {
                                        handleInputChangeForRequiredFields(event);
                                    }}
                                    value={loadProgressData1?.weight || ''}
                                    error={fieldErrors.netWeightError !== ''}
                                    helperText={fieldErrors.netWeightError}
                                    maxLength={40}
                                    disabled={false}
                                    required
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                {!loadDetailData.isBellyDump &&  <div>
                    <div className="LoadFieldOp-Header">
                        <div className="LoadFieldOp-HeaderTitle">Inventory/Staging</div>
                    </div>
                    <div className="LoadFieldOp-LoadDetails">
                        <div className="LoadFieldOp-LoadDetailsContainer">
                            <Row>
                                <Col md={4}>
                                    <SearchableDropdown
                                        autoCompleteEnabled={true}
                                        dropdownOptions={stages}
                                        errorMessage={fieldErrors.stageError}
                                        hasError={fieldErrors.stageError !== ''}
                                        id="stage"
                                        label="Stage"
                                        onSelect={(eventKey: string | null) => {
                                            handleAutoCompleteChange('stage', {
                                                id: eventKey,
                                                name: stages,
                                            });
                                        }}
                                        value={''}
                                        endIcon={searchIcon}
                                    />
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className="LoadFieldOp-Header">
                        <div className="LoadFieldOp-HeaderTitle">Empty Box Details</div>
                    </div>
                    <div className="LoadFieldOp-LoadDetails">
                        <div className="LoadFieldOp-LoadDetailsContainer">
                            <Col>
                                <Row>
                                    <span className="LoadFieldOp-LabelText">Select Number of Empty Boxes</span>
                                </Row>
                                <Row>
                                    <span className="LoadFieldOp-LabelText">
                                        <br></br>
                                    </span>
                                </Row>
                                <Row>
                                    <Col md={1}>
                                        <div className="form-check">
                                            <input
                                                id="webViewId"
                                                type="radio"
                                                className="form-check-input"
                                                value={0}
                                                name="chekcboxWeb"
                                                onChange={(event): void => changeStatus(event)}
                                                checked={emptyBoxesCount == 0}
                                            />
                                            <label className="form-check-label">0</label>
                                        </div>
                                    </Col>
                                    <Col md={1}>
                                        <div className="form-check">
                                            <input
                                                type="radio"
                                                className="form-check-input"
                                                value={1}
                                                name="chekcboxWeb"
                                                onChange={(event): void => changeStatus(event)}
                                            />
                                            <label className="form-check-label">1</label>
                                        </div>
                                    </Col>
                                    <Col md={1}>
                                        <div className="form-check">
                                            <input
                                                type="radio"
                                                className="form-check-input"
                                                value={2}
                                                name="chekcboxWeb"
                                                onChange={(event): void => changeStatus(event)}
                                            />
                                            <label className="form-check-label">2</label>
                                        </div>
                                    </Col>
                                </Row>
                                {(emptyBoxesCount == 1 || emptyBoxesCount == 2) && (
                                    <div style={{ float: 'left', paddingTop: 20 }}>
                                        <Row>
                                            <Col>
                                                <Row>
                                                    <span className="LoadFieldOp-LabelText">Empty Box #1</span>
                                                </Row>
                                                <Row>
                                                    <SearchableDropdown
                                                        autoCompleteEnabled={true}
                                                        dropdownOptions={emptyBoxes}
                                                        errorMessage={fieldErrors.emptyBoxNumber1Error}
                                                        hasError={fieldErrors.emptyBoxNumber1Error !== ''}
                                                        id="emptyBoxNumber1"
                                                        label="Empty Box Number 1"
                                                        onSelect={(eventKey: string | null) => {
                                                            handleAutoCompleteChange('emptyBoxNumber1', {
                                                                id: eventKey,
                                                                name: 'emptyBoxNumber1',
                                                            });
                                                        }}
                                                        required
                                                        endIcon={searchIcon}
                                                    />
                                                </Row>
                                            </Col>
                                            {emptyBoxesCount == 2 && (
                                                <Col>
                                                    <Row>
                                                        <span className="LoadFieldOp-LabelText">Empty Box #2</span>
                                                    </Row>
                                                    <Row>
                                                        <SearchableDropdown
                                                            autoCompleteEnabled={true}
                                                            dropdownOptions={emptyBoxes}
                                                            errorMessage={fieldErrors.emptyBoxNumber2Error}
                                                            hasError={fieldErrors.emptyBoxNumber2Error !== ''}
                                                            id="emptyBoxNumber2"
                                                            label="Empty Box Number 2"
                                                            onSelect={(eventKey: string | null) => {
                                                                handleAutoCompleteChange('emptyBoxNumber2', {
                                                                    id: eventKey,
                                                                    name: 'emptyBoxNumber2',
                                                                });
                                                            }}
                                                            required
                                                            endIcon={searchIcon}
                                                        />
                                                    </Row>
                                                </Col>
                                            )}
                                        </Row>
                                    </div>
                                )}
                            </Col>
                        </div>
                    </div>
                </div>}
                <div className="LoadFieldOp-Header">
                    <div className="LoadFieldOp-HeaderTitle">Operator Information</div>
                </div>
                <div className="LoadFieldOp-LoadDetails">
                    <div className="LoadFieldOp-LoadDetailsContainer">
                        <div className="LoadFiledOp-DetailsContainer">
                            <div className="LoadFiledOp-LoadMainDetailsContainer">
                                <Row>
                                    <Col>
                                        <Textfield
                                            label="First Name"
                                            name="firstName"
                                            onChange={event => {
                                                handleInputChangeForRequiredFields(event);
                                            }}
                                            value={''}
                                            error={fieldErrors.firstNameError !== ''}
                                            helperText={fieldErrors.firstNameError}
                                            maxLength={40}
                                            disabled={false}
                                            required
                                        />
                                    </Col>
                                    <Col>
                                        <Textfield
                                            label="Last Name"
                                            name="lastName"
                                            onChange={event => {
                                                handleInputChangeForRequiredFields(event);
                                            }}
                                            value={''}
                                            error={fieldErrors.lastNameError !== ''}
                                            helperText={fieldErrors.lastNameError}
                                            maxLength={40}
                                            disabled={false}
                                            required
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <span className="LoadFieldOp-LabelText">Operator Signature</span>
                                </Row>
                                <Row>
                                    <div className="LoadFieldOp-SignaturePad">
                                        <SignaturePadComponent
                                            penColor="black"
                                            canvasProps={{
                                                width: 330,
                                                height: 100,
                                                backgroundColor: 'rgb(255, 255, 255)',
                                            }}
                                            ref={signatureCanvasRef}
                                            onEnd={handleSignatureEnd}
                                            backgroundColor="rgb(255, 255, 255)"
                                        />
                                    </div>
                                </Row>
                                <Row>
                                    <div className="LoadFieldOp-ButtonWrapper">
                                        <CustomButton
                                            isBordered={true}
                                            title="Clear Signature"
                                            onClick={clearSignature}
                                        />
                                    </div>
                                </Row>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="LoadFieldOp-Header">
                    <div className="LoadFieldOp-HeaderTitle">Sand Ticket Image</div>
                </div>
                <div className="LoadFieldOp-LoadDetails">
                    <div className="LoadFieldOp-LoadDetailsContainer">
                        <div className="LoadFiledOp-DetailsContainer">
                            <div className="LoadFiledOp-LoadMainDetailsContainer">{sandTicketComponent}</div>
                            <div className="Load-Field-Op-Assign-Error">{fieldErrors.mainError}</div>
                            <div>
                                <CustomButton
                                    title="Save"
                                    onClick={() => {
                                        handleSubmit();
                                    }}
                                    isDisabled={disable}
                                ></CustomButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/********************************* For Tab ***********************************/}
            <div className="LoadFieldOpDetails-For-tab">
                <div className="LoadFieldOp-LoadDetails">
                    <div className="LoadFieldOp-LoadDetailsContainer-For-Tab">
                        <Row>
                            <Col>
                                <Row>
                                    <TextContent
                                        hasTopMargin
                                        title={'Load Id: '}
                                        value={loadDetailData.loadId.toString() || ''}
                                    ></TextContent>
                                </Row>

                                <Row>
                                    <TextContent
                                        hasTopMargin
                                        title={'Well Name: '}
                                        value={loadDetailData.jobName || ''}
                                    ></TextContent>
                                </Row>

                                <Row>
                                    <TextContent
                                        hasTopMargin
                                        title={'Carrier: '}
                                        value={loadDetailData.carrierName || ''}
                                    ></TextContent>
                                </Row>

                                {!loadDetailData.isBellyDump &&<Row>
                                    <label className="LoadFieldOp-Dropdown-Title">{'Chassis: '} </label>
                                    <SearchableDropdown
                                        autoCompleteEnabled={true}
                                        dropdownOptions={chasis}
                                        errorMessage={fieldErrors.chassisNumberError}
                                        hasError={fieldErrors.chassisNumberError !== ''}
                                        id="chassisNumber"
                                        label=""
                                        onSelect={(eventKey: string | null) => {
                                            handleAutoCompleteChange('chassisNumber', {
                                                id: eventKey,
                                                name: inputs.chasis,
                                            });
                                        }}
                                        value={checkForChassisNumber()}
                                        endIcon={searchIcon}
                                    />
                                </Row>}

                                <Row>
                                    <TextContent
                                        hasTopMargin
                                        title={'Proppant: '}
                                        value={loadDetailData.proppantName || ''}
                                    ></TextContent>
                                </Row>

                                <Row>
                                    <TextContent
                                        hasTopMargin
                                        title={'Sand PO: '}
                                        value={loadDetailData.sandPO || ''}
                                    ></TextContent>
                                </Row>

                                <Row>
                                    <label className="LoadFieldOp-TextInput-Title">{'Gross Weight: '} </label>

                                    <div style={{ width: 150 }}>
                                        <Textfield
                                            label=""
                                            name="grossWeight"
                                            onChange={event => {
                                                handleInputChangeForRequiredFields(event);
                                            }}
                                            value={loadProgressData1?.grossWeight || ''}
                                            error={fieldErrors.grossWeightError !== ''}
                                            helperText={fieldErrors.grossWeightError}
                                            maxLength={40}
                                            disabled={false}
                                        />
                                    </div>
                                </Row>

                                <Row>
                                    <label className="LoadFieldOp-TextInput-Title">{'Net Weight: '} </label>

                                    <div style={{ width: 150 }}>
                                        <Textfield
                                            label=""
                                            name="netWeight"
                                            onChange={event => {
                                                handleInputChangeForRequiredFields(event);
                                            }}
                                            value={loadProgressData1?.weight || ''}
                                            error={fieldErrors.netWeightError !== ''}
                                            helperText={fieldErrors.netWeightError}
                                            maxLength={40}
                                            disabled={false}
                                        />
                                    </div>
                                </Row>
                            </Col>

                            <Col>
                                <Row>
                                    <TextContent
                                        hasTopMargin
                                        title={'Customer Name: '}
                                        value={loadDetailData.customerName || ''}
                                    ></TextContent>
                                </Row>

                                <Row>
                                    <TextContent
                                        hasTopMargin
                                        title={'Lofa Name: '}
                                        value={loadDetailData.loadingFacility || ''}
                                    ></TextContent>
                                </Row>

                                <Row>
                                    <label className="LoadFieldOp-TextInput-Title">{'Truck Number: '} </label>

                                    <div style={{ width: 150 }}>
                                        <Textfield
                                            label=""
                                            name="truckNumber"
                                            onChange={event => {
                                                handleInputChangeForRequiredFields(event);
                                            }}
                                            error={fieldErrors.truckNumberError !== ''}
                                            helperText={fieldErrors.truckNumberError}
                                            value={checkForTruckNumber()}
                                            maxLength={40}
                                            disabled={false}
                                        />
                                    </div>
                                </Row>

                               {!loadDetailData.isBellyDump && <Row>
                                    <label className="LoadFieldOp-Dropdown-Title">{'Box Number: '} </label>
                                    <SearchableDropdown
                                        autoCompleteEnabled={true}
                                        dropdownOptions={boxes}
                                        errorMessage={fieldErrors.boxNumberError}
                                        hasError={fieldErrors.boxNumberError !== ''}
                                        id="boxNumber"
                                        label=""
                                        onSelect={(eventKey: string | null) => {
                                            handleAutoCompleteChange('boxNumber', {
                                                id: eventKey,
                                                name: 'boxNumber',
                                            });
                                        }}
                                        value={checkForBoxNumber()}
                                        endIcon={searchIcon}
                                    />
                                </Row>}

                                <Row>
                                    <TextContent
                                        hasTopMargin
                                        title={'Miles: '}
                                        value={loadProgressData1?.milesToWell || ''}
                                    ></TextContent>
                                </Row>

                                <Row>
                                    <label className="LoadFieldOp-Dropdown-Title">{'Sand Ticket #: '} </label>

                                    <div style={{ width: 150 }}>
                                        <Textfield
                                            label=""
                                            name="sandTicketNumber"
                                            onChange={event => {
                                                handleInputChangeForRequiredFields(event);
                                            }}
                                            value={loadProgressData1?.sandTicketNumber || ''}
                                            error={fieldErrors.sandTicketNumberError !== ''}
                                            helperText={fieldErrors.sandTicketNumberError}
                                            maxLength={40}
                                            disabled={false}
                                        />
                                    </div>
                                </Row>

                                <Row>
                                    <label className="LoadFieldOp-Dropdown-Title">{'Tare Weight: '} </label>

                                    <div style={{ width: 150 }}>
                                        <Textfield
                                            label=""
                                            name="tareWeight"
                                            onChange={event => {
                                                handleInputChangeForRequiredFields(event);
                                            }}
                                            value={loadProgressData1?.tareWeight || ''}
                                            error={fieldErrors.tareWeightError !== ''}
                                            helperText={fieldErrors.tareWeightError}
                                            maxLength={40}
                                            disabled={false}
                                        />
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </div>
                {!loadDetailData.isBellyDump && <div className="LoadFieldOp-Header">
                    <div className="LoadFieldOp-HeaderTitle-For-Tab">Inventory/Staging</div>
                </div>}
                {!loadDetailData.isBellyDump && <div className="LoadFieldOp-LoadDetails">
                    <div className="LoadFieldOp-LoadDetailsContainer-For-Tab">
                        <Row>
                            <Col md={4}>
                                <SearchableDropdown
                                    autoCompleteEnabled={true}
                                    dropdownOptions={stages}
                                    errorMessage={fieldErrors.stageError}
                                    hasError={fieldErrors.stageError !== ''}
                                    id="stage"
                                    label="Stage"
                                    onSelect={(eventKey: string | null) => {
                                        handleAutoCompleteChange('stage', {
                                            id: eventKey,
                                            name: stages,
                                        });
                                    }}
                                    value={''}
                                    endIcon={searchIcon}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>}
                {!loadDetailData.isBellyDump && <div className="LoadFieldOp-Header">
                    <div className="LoadFieldOp-HeaderTitle-For-Tab">Empty Box Details</div>
                </div>}
                {!loadDetailData.isBellyDump && <div className="LoadFieldOp-LoadDetails">
                    <div className="LoadFieldOp-LoadDetailsContainer-For-Tab">
                        <Col>
                            <Row>
                                <span className="LoadFieldOp-LabelText">Select Number of Empty Boxes</span>
                            </Row>
                            <Row>
                                <Col md={1}>
                                    <div className="form-check">
                                        <input
                                            id="tabViewId"
                                            type="radio"
                                            className="form-check-input"
                                            value={0}
                                            name="checkBoxTab"
                                            onChange={(event): void => changeStatus(event)}
                                            checked={emptyBoxesCount == 0}
                                        />
                                        <label className="form-check-label">0</label>
                                    </div>
                                </Col>
                                <Col md={1}>
                                    <div className="form-check">
                                        <input
                                            type="radio"
                                            className="form-check-input"
                                            value={1}
                                            name="checkBoxTab"
                                            onChange={(event): void => changeStatus(event)}
                                        />
                                        <label className="form-check-label">1</label>
                                    </div>
                                </Col>
                                <Col md={1}>
                                    <div className="form-check">
                                        <input
                                            type="radio"
                                            className="form-check-input"
                                            value={2}
                                            name="checkBoxTab"
                                            onChange={(event): void => changeStatus(event)}
                                        />
                                        <label className="form-check-label">2</label>
                                    </div>
                                </Col>
                            </Row>
                            {(emptyBoxesCount == 1 || emptyBoxesCount == 2) && (
                                <div style={{ float: 'left', paddingTop: 20 }}>
                                    <Row>
                                        <Col>
                                            <Row>
                                                <span className="LoadFieldOp-LabelText">Empty Box #1</span>
                                            </Row>
                                            <Row>
                                                <SearchableDropdown
                                                    autoCompleteEnabled={true}
                                                    dropdownOptions={emptyBoxes}
                                                    errorMessage={fieldErrors.emptyBoxNumber1Error}
                                                    hasError={fieldErrors.emptyBoxNumber1Error !== ''}
                                                    id="emptyBoxNumber1"
                                                    label="Empty Box Number 1"
                                                    onSelect={(eventKey: string | null) => {
                                                        handleAutoCompleteChange('emptyBoxNumber1', {
                                                            id: eventKey,
                                                            name: 'emptyBoxNumber1',
                                                        });
                                                    }}
                                                    required
                                                    value={''}
                                                    endIcon={searchIcon}
                                                />
                                            </Row>
                                        </Col>
                                        {emptyBoxesCount == 2 && (
                                            <Col>
                                                <Row>
                                                    <span className="LoadFieldOp-LabelText">Empty Box #2</span>
                                                </Row>
                                                <Row>
                                                    <SearchableDropdown
                                                        autoCompleteEnabled={true}
                                                        dropdownOptions={emptyBoxes}
                                                        errorMessage={fieldErrors.emptyBoxNumber2Error}
                                                        hasError={fieldErrors.emptyBoxNumber2Error !== ''}
                                                        id="emptyBoxNumber2"
                                                        label="Empty Box Number 2"
                                                        onSelect={(eventKey: string | null) => {
                                                            handleAutoCompleteChange('emptyBoxNumber2', {
                                                                id: eventKey,
                                                                name: 'emptyBoxNumber2',
                                                            });
                                                        }}
                                                        required
                                                        value={''}
                                                        endIcon={searchIcon}
                                                    />
                                                </Row>
                                            </Col>
                                        )}
                                    </Row>
                                </div>
                            )}
                        </Col>
                    </div>
                </div>}
                <div className="LoadFieldOp-Header">
                    <div className="LoadFieldOp-HeaderTitle-For-Tab">Operator Information</div>
                </div>
                <div className="LoadFieldOp-LoadDetails">
                    <div className="LoadFieldOp-LoadDetailsContainer-For-Tab">
                        <Row>
                            <Col>
                                <Row>
                                    <label className="LoadFieldOp-Dropdown-Title">{'First Name: '} </label>

                                    <div style={{ width: 150 }}>
                                        <Textfield
                                            label=""
                                            name="firstName"
                                            onChange={event => {
                                                handleInputChangeForRequiredFields(event);
                                            }}
                                            value={''}
                                            error={fieldErrors.firstNameError !== ''}
                                            helperText={fieldErrors.firstNameError}
                                            maxLength={40}
                                            disabled={false}

                                            //required
                                        />
                                    </div>
                                </Row>
                            </Col>

                            <Col>
                                <Row>
                                    <label className="LoadFieldOp-Dropdown-Title">{'Last Name: '} </label>

                                    <div style={{ width: 150 }}>
                                        <Textfield
                                            label=""
                                            name="lastName"
                                            onChange={event => {
                                                handleInputChangeForRequiredFields(event);
                                            }}
                                            value={''}
                                            error={fieldErrors.lastNameError !== ''}
                                            helperText={fieldErrors.lastNameError}
                                            maxLength={40}
                                            disabled={false}
                                        />
                                    </div>
                                </Row>
                            </Col>
                        </Row>

                        <Row>
                            <span className="LoadFieldOp-LabelText">Operator Signature</span>
                        </Row>

                        <Row>
                            <div className="LoadFieldOp-SignaturePad">
                                <SignaturePadComponent
                                    penColor="black"
                                    canvasProps={{
                                        width: 330,
                                        height: 100,
                                        backgroundColor: 'rgb(255, 255, 255)',
                                    }}
                                    ref={signatureCanvasRefTab}
                                    onEnd={handleSignatureEndTab}
                                    backgroundColor="rgb(255, 255, 255)"
                                />
                            </div>
                        </Row>

                        <Row>
                            <div className="LoadFieldOp-ButtonWrapper">
                                <CustomButton isBordered={true} title="Clear Signature" onClick={clearSignatureTab} />
                            </div>
                        </Row>
                    </div>
                </div>
                <div style={{ height: 200, overflow: 'hidden', marginBottom: 10 }}>{sandTicketComponent}</div>
                <div className="Load-Field-Op-Assign-Error">{fieldErrors.mainError}</div>
                <div className="LoadFiledOp-ButtonContainer-For-Tab">
                    <div className="LoadFieldOp-SaveButtonWrapper">
                        <CustomButton
                            title="Save"
                            onClick={() => {
                                handleSubmit();
                            }}
                            isDisabled={disable}
                        ></CustomButton>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default LoadFieldOpDetail;
